import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { WINDOW } from "./window.providers";
import { environment } from "../../../environments/environment";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private _config: any;
  config$ = new ReplaySubject<any>(1);

  set config(data: any) {
    this._config = data;
    this.config$.next(data);
  }

  get config() {
    return this._config;
  }

  constructor(
    @Inject(WINDOW) private window: Window,
    private httpClient: HttpClient,
  ) { }

  load(): Promise<any> {
    // A LAN IP or "localhost" is a local dev host and has no skin config of its
    // own, so fall back to the skin configured in the environment file.
    const currentHost = this.window.location.hostname;
    const isLocalHost =
      currentHost.includes("localhost") ||
      /^\d{1,3}(\.\d{1,3}){3}$/.test(currentHost);
    const hostname = isLocalHost ? environment?.domainname : currentHost;
    const params = new HttpParams().set("_", Date.now().toString());

    return this.httpClient
      .get(`${environment?.dataSource}/config/${hostname}.json`, { params })
      .pipe(
        tap((configData) => {
          configData["settings"]["languages"].push({
            value: "fr",
            displayText: "French",
          });
          configData["settings"]["languages"].push({
            value: "he",
            displayText: "Hebrew",
          });
          configData["settings"]["languages"].push({
            value: "uk",
            displayText: "Ukrainian",
          });

          if (configData["code"] === "8dragons-fbif") {
            configData["settings"]["languages"] = [
              { value: "en", displayText: "English" },
              { value: "cn", displayText: "Chinese" },
            ];
            configData["settings"]["defaultLanguage"] = "en";
          }

          if (configData["code"] === "cwop-fxmv") {
            configData["settings"]["defaultLanguage"] = "br";
          }

          if (configData["code"] === "kingpkr-cboz") {
            configData["settings"]["defaultLanguage"] = "ru";
          }

          configData["lobbyGameTypeFilters"] = configData[
            "lobbyGameTypeFilters"
          ].map((el) => {
            if (el.realValue === 1) {
              el.displayValue = "page.lobby.cashGames";
            }
            if (el.realValue === 2) {
              el.displayValue = "page.lobby.sitAndGo";
            }
            if (el.realValue === 4) {
              el.displayValue = "page.lobby.tourney";
            }
            if (el.realValue === 16) {
              el.displayValue = "page.lobby.spinAndGo";
            }
            return el;
          });

          configData["newLayout"] =
            configData["code"] === "newwavepoker-cxzo" ||
            configData["code"] === "newwavepokertest-kwwa" ||
            configData["code"] === "checkraise-btkg" ||
            configData["code"] === "concordebet-gyem" ||
            configData["code"] === "hunnupoker-esqi" 
            // configData["brand"] === "devRyops2";

          configData["newDesign"] =
            configData["brand"] === "cantobyte"
          // || configData["brand"] === "devRyops2";

          configData["lobbyHome"] = false && configData["settings"]?.["homeLobbyScreen"];

          configData["depositGatewayTiles"] = configData["settings"]?.["depositGatewayTiles"];

          configData["tileLobbyOption"] = false;


          const modeRaw =
            configData["settings"]?.["mode"] ??
            configData["lobbyTheme"] ??
            configData["settings"]?.["lobbyTheme"];
          const mode = modeRaw === "light" ? "light" : "dark";
          configData["mode"] = mode;
          configData["lobbyTheme"] = mode;
          if (configData["settings"]) {
            configData["settings"]["mode"] = mode;
          }

          // table skin, deck (backCards) and table background (carpets) use the
          // full arrays from skinSettings — admin controls count via JSON items.

          this.config = configData;

          if (this.config.skinSettings.backCards) {
            this.config.skinSettings.backCards =
              this.config.skinSettings.backCards.map((card) => {
                card.cardUrl = `${environment.dataSource}/${card.cardUrl}`;
                return card;
              });
          }

          if (this.config.skinSettings.tables) {
            this.config.skinSettings.tables.landscape =
              this.config.skinSettings.tables.landscape.map((table) => {
                table.tableUrl = `${environment.dataSource}/${table.tableUrl}`;
                return table;
              });
            this.config.skinSettings.tables.portrait =
              this.config.skinSettings.tables.portrait.map((table) => {
                table.tableUrl = `${environment.dataSource}/${table.tableUrl}`;
                return table;
              });
          }

          if (this.config.skinSettings.carpets) {
            this.config.skinSettings.carpets.landscape =
              this.config.skinSettings.carpets.landscape.map((carpet) => {
                carpet.carpetUrl = `${environment.dataSource}/${carpet.carpetUrl}`;
                return carpet;
              });
            this.config.skinSettings.carpets.portrait =
              this.config.skinSettings.carpets.portrait.map((carpet) => {
                carpet.carpetUrl = `${environment.dataSource}/${carpet.carpetUrl}`;
                return carpet;
              });
          }
        }),
      )
      .toPromise();
  }
}
